import './NewGamePage.scss'
import {t} from "i18next";

const NewGamePage = (props) => {
  const {
    onChangeView,
    onResetGame,
  } = props

  const onStartNewGame = (days) => {
    onResetGame(days)
    onChangeView("PCScreenPage")
  }

  return <div className="NewGamePage">
    <div className="NewGamePage-body">
      <div className="header">{t('ng-choose')} </div>
      <div className="multiline">
        <button className="line line-5" onClick={()=>onStartNewGame(3)}> {t('ng-3')} </button>
        <button className="line line-10" onClick={()=>onStartNewGame(5)}> {t('ng-5')} </button>
        <button className="line line-14" onClick={()=>onStartNewGame(7)}> {t('ng-7')} </button>
      </div>
      <button className="back-button" onClick={()=>onChangeView("MenuPage")}> {t('back')} </button>
    </div>
  </div>
}

export default NewGamePage